import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100 border-t border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <Reveal className="lg:col-span-4">
            <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">FAQ</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">常见问题</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              关于“伦理电影”“中字高清”“合集与推荐”这些说法，先把最容易混淆的地方讲清楚。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="text-sm leading-relaxed text-foreground-600">
                还有想确认的？可以在页面顶部的导航里回到任意分区，继续按需浏览。
              </p>
              <a
                href="#genres"
                className="mt-4 inline-flex items-center gap-2 text-sm font-label text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-up-line"></i>
                回到题材导览
              </a>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <Reveal>
              <ul className="space-y-3">
                {faqs.map((f, i) => {
                  const isOpen = open === i;
                  return (
                    <li key={f.q} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? null : i)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 md:py-5 cursor-pointer hover:bg-background-100 transition-colors"
                      >
                        <span className="flex items-baseline gap-3">
                          <span className="font-heading text-sm text-accent-600">{String(i + 1).padStart(2, "0")}</span>
                          <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">{f.q}</span>
                        </span>
                        <i
                          className={`shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                            isOpen ? "ri-subtract-line" : "ri-add-line"
                          }`}
                        ></i>
                      </button>
                      <div
                        className={`grid transition-all duration-300 ease-out ${
                          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}